var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"waitLoad text-center text-danger my-2",class:_vm.relative ? 'prelative' : ''},[_c('b-spinner',{staticClass:"align-middle"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }